import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ep-dropdown-option',
  templateUrl: './ep-dropdown-option.component.html',
  styleUrls: ['./ep-dropdown-option.component.scss'],
})
export class EpDropdownOptionComponent {
  @Input() value: any;
  @HostBinding('class.selected') @Input() selected: boolean = false;
  @HostBinding('class.disabled') @Input() disabled: boolean = false;
  @Output() optionSelect = new EventEmitter<any>();

  @HostListener('click')
  public select(): void {
    if (!this.disabled) {
      this.optionSelect.emit(this.value);
    }
  }
}
